import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  settings: {},
};
const settingSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setSettings: (state, { payload }) => {
      state.settings = payload;
    },
  },
});

export default settingSlice;
/**
 * @param {} state
 * @returns { import("../../..").CompanySetting }
 */
export const companySettingsSelector = (state) => state.companySettings?.settings;

/**
 * @param {} state
 * @returns { import("../../..").IInstrument[] }
 */
export const instrumentsSettingsSelector = (state) => companySettingsSelector(state)?.instruments;

/**
 * @param {} state
 * @returns { import("../../..").TTemplate }
 */
export const templateSettingsSelector = (state) => companySettingsSelector(state)?.template;

/**
 * @param {} state
 * @returns { import("../../..").IFormatSetting }
 */
export const formatSettingsSelector = (state) => companySettingsSelector(state)?.format;

export const { setSettings } = settingSlice.actions;
